var aesEcb = require("aes-ecb");
const salt = process.env.REACT_APP_CLIENT_KEY;

export const encrypt = (data) => {
  let result = aesEcb.encrypt(salt,data)
  return result.toString();
};

export const decrypt = (data) => {
let result = aesEcb.decrypt(salt,data)
return result
};
